let resource = require('vue-resource');
let Mint = require('mint-ui');
var enviroment = process.env.NODE_ENV == 'production' ? 'PRD' : 'DEV';
var apiUrl = {
    DEV: 'https://gateway-dev.smarteventcloud.cn',
    PRD: 'https://gateway.smarteventcloud.cn'
}[enviroment];
function Handle(method, url, data, res) {
    Mint.Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
    });
    if (sessionStorage.getItem('token') && method != 'login') {
        resource.Http.headers.common['Authorization'] = 'Bearer' + ' ' + sessionStorage.getItem('token');
    }
    url = apiUrl + url;
    resource.Http.options.emulateJSON = false;
    if (method == 'get') {
        if (data) {
            url += '?'
            for (let key in data) {
                if (data[key]) {
                    url += key + '=' + data[key] + '&';
                }
            }
        }
        resource.Http.get(url + data)
            .then((response) => {
                returnData(res, response);
            }).catch(function (response) {
            onError(response);
        })
    }
    if (method == 'post') {
        resource.Http.post(url, data)
            .then((response) => {
                returnData(res, response);
            }).catch(function (response) {
            onError(response);
        })
    }
    if (method == 'login') {
        resource.Http.options.emulateJSON = true;
        resource.Http.post(url, data)
            .then((response) => {
                if (response.status == '200') {
                    res(response.body);
                    Mint.Indicator.close();
                } else {
                    onError(response);
                }
            }).catch(function (response) {
            onError(response);
        })
    }
    if (method == 'delete') {
        resource.Http.delete(url + data.id).then((response) => {
            returnData(res, response);
        }).catch(function (response) {
            onError(response);
        })
    }
}
function returnData(res, response) {
    Mint.Indicator.close();
    if (!response.body.success) {
        onError(response);
    } else {
        res(response.body);
    }
}
function onError(response) {
    console.log(response)
    if (response.body) {
        response = response.body.msg || response.body.error_description || response.body.error || '请求失败'
    }
    Mint.Indicator.close();
    Mint.Toast(response);
}
let http = {
    get: function (url, data, res) {
        Handle('get', url, data, res)
    },
    login: function (url, data, res) {
        Handle('login', url, data, res)
    },
    post: function (url, data, res) {
        Handle('post', url, data, res)
    },
    delete: function (url, data, res) {
        Handle('delete', url, data, res)
    },
};

export default http;



// WEBPACK FOOTER //
// ./src/api/getData.js